<template>
  <div class="flex flex-nowrap items-center gap-1 mb-8">
    <NamiButton
      v-if="backLocation"
      buttonType="secondary"
      text
      noWaves
      pill
      :icon="IconChevronLeft"
      :href="backLocation"
    />
    <h1 class="lg:text-3xl text-2xl font-semibold">
      <slot />
    </h1>
  </div>
</template>

<script setup lang="ts">
import { IconChevronLeft } from "@tabler/icons-vue";

export type Props = {
  backLocation?: string;
};

const { backLocation } = defineProps<Props>();
</script>
